import { styled, List } from '@mui/material';
/**
 * Styled List component.
 */
export const StyledList = styled(List)(() => ({
    paddingBottom: 0,
    paddingTop: 0,
    position: 'relative',
    width: '100%',
}));
